import React, { PureComponent } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import Production from './production'

export const ENV = process.env.REACT_APP_ENV

class RouterWrapper extends PureComponent {
  render() {
    return (
      <Production admin={this.props.admin} />
    )
  }
}

export default RouterWrapper